import {useAppSelector} from '@/hooks';
import {useSingleActivePosterItem} from '@Hooks/poster-editor/useSingleActivePosterItem';

export function useShouldHideControlsWhenItemAnimating(pageHashedId: string): boolean {
  const hoveredItemId = useAppSelector((state) => state.posterEditor.hoveredItemId[pageHashedId]);
  const isPosterPlaying = useAppSelector((state) => state.posterEditor.isPlaying);

  const activeItem = useSingleActivePosterItem(pageHashedId);
  const hoveredItem = hoveredItemId ? window.posterEditor?.whiteboard?.getItemForId(hoveredItemId) : undefined;

  const isHoveredItemAnimating = hoveredItem?.introAnimation?.animation?.isAnimationPlaying ?? false;
  const isActiveItemAnimating = isPosterPlaying && activeItem?.hasAnimation() === true;

  return isHoveredItemAnimating || isActiveItemAnimating;
}
